<script setup>
import KraftchatAIRulesSwitchItem from './KraftchatAIRulesSwitchItem.vue';

import { toolActionOptions } from '../../helpers/kraftchatAIRulesConfig';

const props = defineProps({
  policy: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update:policy']);

const updateAction = (key, value) => {
  emit('update:policy', {
    ...props.policy,
    allowed_actions: {
      ...(props.policy.allowed_actions || {}),
      [key]: value,
    },
  });
};
</script>

<template>
  <div class="grid gap-3 md:grid-cols-2">
    <KraftchatAIRulesSwitchItem
      v-for="action in toolActionOptions"
      :key="action.key"
      :label="action.title"
      :description="action.description"
      :model-value="policy.allowed_actions?.[action.key]"
      @update:model-value="updateAction(action.key, $event)"
    />
  </div>
</template>
